// Scope: presents Sahil's professional profile, experience, education, and credentials.

import React, { useState } from "react";
import ExperienceTimeline from "../components/AboutPage/ExperienceTimeline";
import PFitems from "../assets/professionalData.js";
import { educationData, certificationData } from "../assets/educationData.js";

const TABS = [
    { id: "professional", label: "Experience", data: PFitems },
    { id: "education", label: "Education", data: educationData },
    { id: "certifications", label: "Certifications", data: certificationData },
];

const AboutPage = () => {
    const [activeTab, setActiveTab] = useState("professional");
    const current = TABS.find((tab) => tab.id === activeTab);

    return (
        <div className="about-page">
            <p className="section-label">About</p>
            <div className="about-hero">
                <div className="about-hero__intro">
                    <p className="about-hero__eyebrow">Finance professional · Software builder</p>
                    <h1 className="about-hero__title">Turning operational complexity into useful software.</h1>
                    <p className="about-hero__text">
                        I combine finance, analytics, and full-stack development to build dashboards,
                        APIs, and workflow tools that help teams make clearer decisions and work efficiently.
                    </p>
                </div>
                <aside className="about-focus" aria-label="Areas of focus">
                    <p className="about-focus__label">How I work</p>
                    <div className="about-focus__item">
                        <span>01</span><div><strong>Understand the operation</strong><p>Start with the people, decisions, and constraints behind the process.</p></div>
                    </div>
                    <div className="about-focus__item">
                        <span>02</span><div><strong>Shape the information</strong><p>Turn complex data into clear measures, interfaces, and priorities.</p></div>
                    </div>
                    <div className="about-focus__item">
                        <span>03</span><div><strong>Build for real use</strong><p>Deliver maintainable tools with thoughtful guardrails and practical UX.</p></div>
                    </div>
                </aside>
            </div>

            <div className="about-tabs" role="tablist" aria-label="About sections">
                {TABS.map((tab) => (
                    <button
                        key={tab.id}
                        type="button"
                        role="tab"
                        id={`about-tab-${tab.id}`}
                        aria-controls="about-tabpanel"
                        aria-selected={activeTab === tab.id}
                        className={`about-tab${activeTab === tab.id ? " about-tab--active" : ""}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div className="about-timeline-wrap" id="about-tabpanel" role="tabpanel" aria-labelledby={`about-tab-${activeTab}`}>
                <ExperienceTimeline data={current.data} />
            </div>
        </div>
    );
};

export default AboutPage;
